import { Directive, ElementRef, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({ selector: '[togTrailingText]' })

export class TrailingTextDirective {
  currentTrail: any;
  div: any;
  inputWidth: number;
  innerText: string;

  @Input() set textToTrail(text: string) {
    if(text && text.length) {
      this.currentTrail = document.createElement('div');
      this.currentTrail.style.top = '8px';
      this.currentTrail.style.left = (10 + this.getWidth(this._el.nativeElement.value)).toString() + 'px';
      this.currentTrail.style.cursor = 'text';
      this.currentTrail.style.position = 'absolute';
      let trailText = document.createTextNode(text);
      this.currentTrail.appendChild(trailText);
      this._el.nativeElement.parentNode.appendChild(this.currentTrail);
    }
    if((!text || text.length === 0) && this.currentTrail) {
      this._el.nativeElement.parentNode.removeChild(this.currentTrail);
      this.currentTrail = null;
    }
  }

  @Input() set rawInput(text: string) {
    let left: number;
    this.innerText = text;

    if(this._el.nativeElement.parentNode.contains(this.currentTrail)) {
      left = 10 + this.getWidth(text);
      if(left > (this.inputWidth - 82)) {
        this._el.nativeElement.style.paddingRight = '87px';
        this._el.nativeElement.style.left = '';
        this.div.innerText = '';
        this.currentTrail.style.right = 5 + 'px';
      }
      else {
        this.currentTrail.style.left = left.toString() + 'px';
        this._el.nativeElement.style.paddingRight = '0px';

      }
    }
  }

  constructor(private _el: ElementRef) {
    this.div = document.createElement('div');
    this.div.style.visibility = 'hidden';
    this.div.style.width = 'auto';
    this.div.style.display = 'inline-block';
    this.div.style.whiteSpace = 'nowrap';
    this.div.style.fontWeight = 'normal';
    this.div.style.fontFamily = 'Roboto';
    this.div.style.fontSize = '12px';
    this.div.style.cursor = 'text';
    this._el.nativeElement.parentNode.appendChild(this.div);
    this._el.nativeElement.style.textOverflow = 'ellipsis';
   }

  getWidth(text): number {
    this.div.innerText = text;
    this.inputWidth = this._el.nativeElement.clientWidth;
    return this.div.getBoundingClientRect().width;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    let left;
    if (this._el.nativeElement.parentNode.contains(this.currentTrail)) {
      left = 10 + this.getWidth(this._el.nativeElement.value);
      setTimeout(() => {
        if (left > (this.inputWidth - 82)) {
          this._el.nativeElement.style.paddingRight = '87px';
          this.div.innerText = '';
          this.currentTrail.style.right = 5 + 'px !important';
          this.currentTrail.style.left = '';
        }
        else {
          this.currentTrail.style.left = left.toString() + 'px';
          this._el.nativeElement.style.paddingRight = '0px';
        }
      }, 0);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/trailing-text/trailing-text.directive.ts